import { Component, OnInit } from '@angular/core';
import { AuthorizeService } from 'src/app/services/authorize/authorize.service';
import { finalize } from 'rxjs/operators';
import { CustomerService } from 'src/app/services/customer/customer.service';
import { ColDef, GridOptions, GridReadyEvent, GridSizeChangedEvent, SideBarDef } from 'ag-grid-community';
import { Router } from '@angular/router';

@Component({
  selector: 'app-customer-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss'],
})


export class CustomerAlertsComponent implements OnInit {
    gridClass = 'ag-theme-alpine-dark';
    isLoading: boolean = false;
    rowData: any[]= [];
    custId?: number;


    public readonly gridOptions: GridOptions = {};

    public sideBar: SideBarDef = {
        toolPanels: [
            {
                id: 'columns',
                labelDefault: 'Columns',
                labelKey: 'columns',
                iconKey: 'columns',
                toolPanel: 'agColumnsToolPanel',
                toolPanelParams: {
                    suppressRowGroups: true,
                    suppressValues: true,
                    suppressPivots: true,
                    suppressPivotMode: true,
                    suppressColumnFilter: true,
                    suppressColumnSelectAll: true,
                    suppressColumnExpandAll: true,
                },
            },
        ],
        defaultToolPanel: '',
    };

    colDefs: ColDef[] = [
        { field: 'customer', sortable: true, filter: "agTextColumnFilter", tooltipField: "Customer", headerName: "Customer", floatingFilter: true },
        { field: 'alertMessage', sortable: true, filter: "agTextColumnFilter", tooltipField: "Alert", headerName: "Alert", floatingFilter: true },
        { field: 'account', sortable: true, filter: "agTextColumnFilter", tooltipField: "Account", hide: true, headerName: "Account", floatingFilter: true },
        // { field: 'timeRaised', sortable: true, filter: "agTextColumnFilter", tooltipField: "Time Alert Was Raised", hide: true, headerName: "Time Raised", floatingFilter: true, cellRenderer: (data: { value: MomentInput; }) => {
        //     return moment(data.value).format('MM/DD/YYYY HH:mm')
        // } },
        // { field: 'emailSent', sortable: true, filter: "agTextColumnFilter", tooltipField: "Email Sent", headerName: "Email Sent", hide: true, floatingFilter: true,cellRenderer: (data: { value: MomentInput; }) => {
        //     return moment(data.value).format('MM/DD/YYYY HH:mm')
        // } }
    ];

    public defaultColDef: ColDef = {
        sortable: true,
        filter: true,
        resizable: true
      };


    constructor(
        private _authorizeService: AuthorizeService,
        private _customerDataService: CustomerService,
        private _router: Router
    ) {
        this._authorizeService.user$.subscribe(user => {
            this.custId = user?.customerId;
          });
    }

    ngOnInit() {
        if (localStorage.getItem('theme') == "light") {
            this.gridClass = 'ag-theme-alpine';
        } else {
            this.gridClass = 'ag-theme-alpine-dark';
        }

        if ("custAlertsData" in sessionStorage) {
            let custAlertsJson = sessionStorage.getItem("custAlertsData") || '{}';
            this.rowData = JSON.parse(custAlertsJson);
        } else {
            this.isLoading = true;
            this._customerDataService.getCustomerTankAlerts$(this.custId!)
            .pipe(
                finalize(() => {
                    this.isLoading = false;
                })
            ).subscribe((data: any) => this.rowData = data);
        }
    }

    onGridReady(params: GridReadyEvent) {
        params.api.sizeColumnsToFit();
        params.api.resetRowHeights();
        params.api.setDomLayout('autoHeight');
    }

    onGridSizeChanged(params: GridSizeChangedEvent) {
        params.api.sizeColumnsToFit();
    }

}
